const Configurations = {
    init: function () {
        this.Default.init();
        this.Article.init();
    },
    Default: {
        init: function () {
            this.index();
        },

        index: function () {
            const table_id = 'default_datatable';
            const table = $('#'.concat(table_id));
            table.DataTable({
                responsive: true,
            });
        },
    },
    Article: {
        init: function () {
            this.index();
        },

        index: function () {
            const table_id = 'articles_datatable';
            const table = $('#'.concat(table_id));
            table.DataTable({
                responsive: true,
                columnDefs: [
                    {
                        targets: 5,
                        render: function (data, type, full, meta) {
                            const status = {
                                'active': {'title': 'فعال', 'state': 'success'},
                                'inactive': {'title': 'غیرفعال', 'state': 'danger'},
                            };
                            if (typeof status[data] === 'undefined') {
                                return data;
                            }
                            return '<span class="label label-' + status[data].state + ' label-dot mr-2"></span>' +
                                '<span class="font-weight-bold text-' + status[data].state + '">' + status[data].title + '</span>';
                        },
                    },
                ],
            });
        },
    },
}
export default Configurations;